import React from "react";
import "./Skills.css";

const Skills = () => {

  return (
    <section id="skills" className="skills">
      <div className="skills-container">
        <h2>My Skills</h2>

        <ul className="skills-list">
          <li className="md-chip"> Node JS </li>
          <li className="md-chip"> Express </li>
          <li className="md-chip"> Microservices </li>
          <li className="md-chip"> React </li>
          <li className="md-chip"> MongoDB </li>
          <li className="md-chip"> API </li>
          <li className="md-chip"> Postgres SQL </li>
          <li className="md-chip"> Socket.IO </li>
          <li className="md-chip"> Javascript </li>
          <li className="md-chip"> Sequelize </li>
          <li className="md-chip"> Mongoose </li>
          <li className="md-chip"> Git </li>
          <li className="md-chip"> jQuery </li>
          <li className="md-chip"> Grunt </li>
          <li className="md-chip"> Microfrontend </li>
          <li className="md-chip"> Design System </li>
        </ul>
      </div>
    </section>
  );
};

export default Skills;
